import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { SeoService } from '../../seo/seo.service';

@Component({
  selector: 'app-giulianova-teramo',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './giulianova-teramo.html',
  styleUrl: './giulianova-teramo.scss',
})
export class GiulianovaTeramoComponent implements OnInit {
  readonly services = [
    ['Pulizia condomini', 'Scale, androni, ascensori, vetrate e spazi comuni con interventi programmati.', '/condomini'],
    ['Pulizia uffici e aziende', 'Piani flessibili per uffici pubblici e privati, studi, negozi e attività commerciali.', '/uffici'],
    ['Sanificazioni', 'Igienizzazione professionale di ambienti di lavoro, spazi condivisi e locali aperti al pubblico.', '/sanificazioni'],
    ['Pulizie straordinarie', 'Interventi profondi, post cantiere, post ristrutturazione e pulizie una tantum.', '/straordinaria'],
    ['Palestre e centri sportivi', 'Pulizia di sale, attrezzature, spogliatoi, docce e aree comuni.', '/palestra'],
    ['Case e appartamenti', 'Pulizie domestiche periodiche o su richiesta per abitazioni e seconde case.', '/domestica'],
  ];

  readonly areas = [
    'Giulianova', 'Teramo', 'Roseto degli Abruzzi', 'Alba Adriatica', 'Tortoreto',
    'Silvi', 'Pineto', 'Martinsicuro', 'Mosciano Sant’Angelo', 'Atri', 'Bellante',
    'Notaresco', 'Castellalto', 'Sant’Egidio alla Vibrata',
  ];

  readonly faqs = [
    {
      question: 'Come contatto la sede di Giulianova?',
      answer: 'Puoi chiamare lo 085 9155805 oppure compilare il modulo preventivo selezionando Giulianova. La sede si trova in Corso Nazario Sauro 118.',
    },
    {
      question: 'Quali zone della provincia di Teramo servite?',
      answer: 'Operiamo a Giulianova, Teramo, Roseto degli Abruzzi, Alba Adriatica, Tortoreto, Silvi, Pineto, Martinsicuro e nelle principali località della provincia, valutando anche comuni limitrofi.',
    },
    {
      question: 'Fate pulizie di condomini e uffici a Teramo?',
      answer: 'Sì. Offriamo pulizie programmate per condomini, uffici, studi professionali, aziende e attività commerciali in tutta l’area servita.',
    },
    {
      question: 'Il sopralluogo e il preventivo sono gratuiti?',
      answer: 'Sì. Analizziamo spazi, frequenza e necessità specifiche per preparare un preventivo personalizzato senza impegno.',
    },
  ];

  constructor(private seo: SeoService) {}

  ngOnInit(): void {
    this.seo.updateTags({
      title: 'Impresa di pulizie Giulianova e Teramo | SAMI Pulizie',
      description: 'Impresa di pulizie a Giulianova, Teramo e provincia. Servizi di pulizia condomini, uffici, attività, palestre e sanificazioni. Preventivo gratuito.',
      keywords: 'impresa pulizie Giulianova, pulizie Teramo, pulizia condomini Giulianova, pulizia uffici Teramo, pulizie Roseto, pulizie Alba Adriatica',
      canonicalUrl: '/impresa-pulizie-giulianova-teramo',
      ogTitle: 'SAMI Pulizie a Giulianova, Teramo e provincia',
      ogDescription: 'Servizi SAMI Pulizie a Giulianova e nella provincia di Teramo. Richiedi un preventivo gratuito.',
      ogImage: '/assets/pullizia-uffici-postazione.webp',
      jsonLd: [
        {
          '@context': 'https://schema.org',
          '@type': 'CleaningService',
          '@id': 'https://samipulizie.it/#giulianova',
          name: 'SAMI Pulizie - Sede di Giulianova',
          url: 'https://samipulizie.it/impresa-pulizie-giulianova-teramo',
          telephone: '+390859155805',
          email: 'commerciale.te@samipulizie.it',
          address: {
            '@type': 'PostalAddress',
            streetAddress: 'Corso Nazario Sauro 118',
            addressLocality: 'Giulianova',
            addressRegion: 'TE',
            postalCode: '64021',
            addressCountry: 'IT',
          },
          geo: {
            '@type': 'GeoCoordinates',
            latitude: 42.7533741,
            longitude: 13.9669969,
          },
          hasMap: 'https://www.google.com/maps/search/?api=1&query=42.7533741%2C13.9669969',
          areaServed: this.areas.map(name => ({ '@type': 'City', name })),
          parentOrganization: {
            '@type': 'Organization',
            name: 'SAMI Pulizie',
            url: 'https://samipulizie.it/',
          },
        },
        {
          '@context': 'https://schema.org',
          '@type': 'Service',
          name: 'Servizi di pulizia professionale a Giulianova e Teramo',
          serviceType: 'Pulizie professionali per condomini, uffici, aziende e privati',
          provider: {
            '@id': 'https://samipulizie.it/#giulianova',
          },
          areaServed: this.areas.map(name => ({ '@type': 'City', name })),
          url: 'https://samipulizie.it/impresa-pulizie-giulianova-teramo',
        },
        {
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: this.faqs.map(faq => ({
            '@type': 'Question',
            name: faq.question,
            acceptedAnswer: { '@type': 'Answer', text: faq.answer },
          })),
        },
      ],
    });
  }
}
